import useTracking, { TrackingFnType } from '@hooks/useTracking'
import { stripHtml } from '@hooks/useTracking/utils'
import {
  FunctionComponent,
  useCallback,
  useContext,
  useEffect,
  useState,
} from 'react'
import SocialButton from './Button'
import config from '@config'
import usePageMetadata from '@hooks/usePageMetadata'
import ToastMessage from './ToastMessage'
import EndOfArticleContext from '@contexts/endOfArticle'
const {
  backend: { baseUrl },
  socialembeds: {
    share: { types: socialEmbedTypes, utmCampaign, utmMedium },
  },
} = config

const Copy: FunctionComponent = () => {
  const endOfArticle = useContext(EndOfArticleContext)
  const pageMetadata = usePageMetadata()
  const [showToast, setShowToast] = useState(false)

  useEffect(() => {
    if (showToast) {
      const timer = setTimeout(
        () => setShowToast((showToast) => !showToast),
        5000
      )
      return () => clearTimeout(timer)
    }
  }, [showToast])

  const trackingOnClick = useCallback<TrackingFnType>(
    ({ pageMetadata }) => {
      return {
        event: 'article_share',
        eventCategory: 'article',
        eventAction: `share_copy_${endOfArticle ? 'bottom' : 'top'}`,
        eventLabel: `${pageMetadata.id}:${stripHtml(pageMetadata.title)}`,
        nonInteraction: false,
      }
    },
    [endOfArticle]
  )

  const trackingFunction = useTracking(trackingOnClick)

  const onClick = useCallback(() => {
    const getFullShareUrlForCopy = () => {
      const {
        copy: { utmSource },
      } = socialEmbedTypes
      const shareUrl = `${baseUrl}${pageMetadata?.url}`
      const utm = `%3Futm_medium%3D${utmMedium}%26utm_campaign%3D${utmCampaign}%26utm_source%3D${utmSource}`
      return `${shareUrl}${decodeURIComponent(utm)}`
    }

    trackingFunction()
    const fullShareUrl = getFullShareUrlForCopy()
    navigator.clipboard.writeText(fullShareUrl)
    setShowToast(true)
  }, [trackingFunction, pageMetadata?.url])

  return (
    <>
      <SocialButton type="copy" onClick={onClick} />
      {showToast && <ToastMessage />}
    </>
  )
}

export default Copy
